module.exports = __webpack_public_path__ + "img/douyin_img.6b8ac547.png";